module.exports = __webpack_public_path__ + "static/batson-torres-eecff6f07fe0bf049efc55d914e5a251.jpg";